export default __webpack_public_path__ + "static/media/icon-membership.32d057d5.svg";